var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from '@angular/core';
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { ImportIntoConfigureGalleryDto, ImportIntoUserGalleryDto, ImportUserGraphIntoConfigureGalleryDto } from '../../../../../shared/service-proxies/service-proxies';
import { GraphicsType } from '../../../shared/helpers/graphics-type-help';
import { ConfigureComponentBase } from '../../../../../shared/configure-component-base';
import { AppConsts } from '../../../../../shared/AppConsts';
import { RenameGraphSettingModalComponent } from '../graph/rename-graph-setting.component';
var GraphImportControlSettingComponent = /** @class */ (function (_super) {
    __extends(GraphImportControlSettingComponent, _super);
    function GraphImportControlSettingComponent(injector, systemGalleryService, galleryService, userGalleryAppSerivceService, modalService, bsModalRef, elRef) {
        var _this = _super.call(this, injector) || this;
        _this.systemGalleryService = systemGalleryService;
        _this.galleryService = galleryService;
        _this.userGalleryAppSerivceService = userGalleryAppSerivceService;
        _this.modalService = modalService;
        _this.bsModalRef = bsModalRef;
        _this.elRef = elRef;
        _this.saving = false;
        _this._onClosed = new Subject();
        return _this;
    }
    Object.defineProperty(GraphImportControlSettingComponent.prototype, "onClosed", {
        get: function () {
            return this._onClosed;
        },
        enumerable: true,
        configurable: true
    });
    GraphImportControlSettingComponent.prototype.ngOnInit = function () {
        this.newGraphStateList = this.graphState.list;
        if (this.graphState.graphicsType === GraphicsType.current) {
            this.getCurrentGalleryStates();
        }
        else {
            this.getUserGalleryStates();
        }
        $(this.elRef.nativeElement).parent('.modal-content').draggable({
            cursor: 'pointer',
            handle: '.modal-header'
        });
    };
    GraphImportControlSettingComponent.prototype.getCurrentGalleryStates = function () {
        var self = this;
        self.userGalleryAppSerivceService.getGraphStates(self.graphState.id).subscribe(function (r) {
            self.oldGraphStateList = [];
            _.each(r.items, function (state) {
                var stateGraph = {
                    id: state.id,
                    name: self.lc('State') + state.index,
                    type: state.type
                };
                stateGraph.url = AppConsts.remoteServiceBaseUrl + state.url;
                self.oldGraphStateList.push(stateGraph);
            });
        });
    };
    GraphImportControlSettingComponent.prototype.getUserGalleryStates = function () {
        var self = this;
        self.galleryService.getGraphStates(self.configureId, self.graphState.id).subscribe(function (r) {
            self.oldGraphStateList = [];
            _.each(r.items, function (state) {
                var stateGraph = {
                    id: state.id,
                    name: self.lc('State') + state.index,
                    type: state.type
                };
                stateGraph.url = AppConsts.remoteServiceBaseUrl + state.url;
                self.oldGraphStateList.push(stateGraph);
            });
        });
    };
    GraphImportControlSettingComponent.prototype.close = function (modalResult) {
        this.bsModalRef.hide();
        this._onClosed.next(modalResult);
        this._onClosed.complete();
    };
    GraphImportControlSettingComponent.prototype.renameGraphName = function () {
        var _this = this;
        var modalRef = this.modalService.show(RenameGraphSettingModalComponent, { initialState: { graphState: this.graphState, configureId: this.configureId }, backdrop: 'static' });
        var onClosedSub = modalRef.content.onClosed.subscribe(function (result) {
            onClosedSub.unsubscribe();
            if (!result) {
                return;
            }
            abp.notify.success(_this.l('SuccessfullySaved'));
            abp.event.trigger('userGraph:Added', result.newName);
            _this.close({ graphName: result.newName });
        });
    };
    GraphImportControlSettingComponent.prototype.replaceGraph = function () {
        var _this = this;
        if (this.graphState.graphicsType === GraphicsType.current) {
            this.converUserGalleryFromCurrentGallery();
            return;
        }
        this.message.confirm(this.lc('ReplaceGraphInfo'), this.l('AreYouSure'), function (isConfirmed) {
            if (isConfirmed) {
                if (_this.graphState.graphicsType === GraphicsType.system) {
                    _this.coverConfigureGalleryFromSystem();
                }
                else {
                    _this.coverConfigureGalleryFromUserGallery();
                }
            }
        });
    };
    GraphImportControlSettingComponent.prototype.coverConfigureGalleryFromSystem = function () {
        var _this = this;
        var input = new ImportIntoConfigureGalleryDto();
        input.configureId = this.configureId;
        input.categoryId = this.graphState.categoryId;
        input.graphId = this.graphState.graphId;
        input.name = this.graphState.name;
        this.saving = true;
        this.systemGalleryService.coverConfigureGalleryFromSystem(input).pipe(finalize(function () { return _this.saving = false; }))
            .subscribe(function () {
            abp.event.trigger('graph:changed', input.graphId);
            _this.notify.info(_this.l('SavedSuccessfully'));
            _this.close({ graphName: input.name });
        });
    };
    GraphImportControlSettingComponent.prototype.coverConfigureGalleryFromUserGallery = function () {
        var _this = this;
        var userInput = new ImportUserGraphIntoConfigureGalleryDto();
        userInput.userGalleryId = this.graphState.userGalleryId;
        userInput.configureId = this.configureId;
        userInput.userGraphId = this.graphState.graphId;
        userInput.userGraphName = this.graphState.name;
        this.saving = true;
        this.userGalleryAppSerivceService.coverConfigureGalleryFromUserGallery(userInput).pipe(finalize(function () { return _this.saving = false; }))
            .subscribe(function () {
            abp.event.trigger('graph:changed', userInput.userGraphId);
            _this.notify.info(_this.l('SavedSuccessfully'));
            _this.close({ graphName: userInput.userGraphName });
        });
    };
    GraphImportControlSettingComponent.prototype.converUserGalleryFromCurrentGallery = function () {
        var _this = this;
        var currentInput = new ImportIntoUserGalleryDto();
        currentInput.userId = this.graphState.userId;
        currentInput.configureId = this.configureId;
        currentInput.configureGraphId = this.graphState.graphId;
        currentInput.graphName = this.graphState.name;
        this.saving = true;
        this.galleryService.coverUserGalleryFromConfigureGallery(currentInput).pipe(finalize(function () { return _this.saving = false; }))
            .subscribe(function (__) {
            abp.event.trigger('graph:changed', currentInput.configureGraphId);
            abp.event.trigger('graph:changed', _this.graphState.id);
            abp.event.trigger('userGraph:Replaced', _this.graphState.name);
            _this.notify.info(_this.l('SavedSuccessfully'));
            _this.close({ graphName: _this.graphState.name });
        });
    };
    GraphImportControlSettingComponent = __decorate([
        Component({
            selector: 'graph-import-control-setting',
            styles: [".graphicsBox{ display: inline-block; width: 280px; margin-right: 7px; .graphics{ width: 100%; height: 47%; overflow-y: auto; border: 1px solid #dddddd; .graph { width: 64px; height: 64px; border: 2px solid transparent; } } } .modal-border-bottom{ border-bottom: 1px solid #f4f4f4; } ",
                " .graphList { text-align: center; float: left; width: 64px; height: 100px; margin-left: 10px; margin-top: 10px; .graph { width: 64px; height: 64px; border: 2px solid transparent; display: flex; cursor: pointer; justify-content: center; .svgGraph>svg { width: 100%; height: 100%; } img{ width: auto; height: auto; max-width: 100%; max-height: 100%; align-self: center; } } span { font-size: 12px; word-break: break-word; } .graph.selectedGallery { border-color: #2d89ef; } } .inline-control{ display: inline-block; }"],
            template: "<div class=\"fe-modal-container\"> <div class=\"modal-header fe-modal-header modal-border-bottom\"> <h4 class=\"fe-modal-header-title\"> {{lc(\"GraphSameName\")}} </h4> <div aria-label=\"Close\" class=\"fe-modal-header-close\" (click)=\"close()\">×</div> </div> <div class=\"fe-modal-middle margin-top-10\"> <div class=\"modal-body-content\"> <div> <div class=\"graphicsBox\"> <span>{{lc(\"NewGraph\")}}:</span> <div class=\"graphics\"> <graph-state-list [stateList]=\"newGraphStateList\"></graph-state-list> </div> </div> <div class=\"graphicsBox\"> <span>{{lc(\"OriginalGraph\")}}:</span> <div class=\"graphics\"> <graph-state-list [stateList]=\"oldGraphStateList\"></graph-state-list> </div> </div> </div> </div> </div> <div class=\"fe-modal-footer\"> <div class=\"button-group\"> <button [disabled]=\"saving\" type=\"button\" class=\"fe-btn fe-btn-default fe-btn-save\" (click)=\"renameGraphName()\"> {{lc(\"RenameGraph\")}} </button> <button [disabled]=\"saving\" type=\"button\" class=\"fe-btn fe-btn-default fe-btn-save\" (click)=\"replaceGraph()\"> {{lc(\"ReplaceGraph\")}} </button> <button [disabled]=\"saving\" type=\"button\" class=\"fe-btn fe-btn-default fe-btn-cancel-one\" (click)=\"close()\"> {{l(\"Cancel\")}} </button> </div> </div> </div>"
        })
    ], GraphImportControlSettingComponent);
    return GraphImportControlSettingComponent;
}(ConfigureComponentBase));
export { GraphImportControlSettingComponent };
